














import { defineComponent } from '~/utils/nuxt3-migration'
import CLink from '~/components/shared/configurable/link/CLink.vue'

export default defineComponent({
  props: {
    href: {
      type: String,
      default: null
    },
    to: {
      type: [Object, String],
      default: null
    },
    target: {
      type: String,
      default: '_self'
    }
  },
  components: { CLink }
})
